import http from '@libs/http';
import {
  PortfolioQuery,
  VirtualPortfolioQuery,
  EmbeddedPutOptionSymbolsQuery,
  EmbeddedPutOptionSymbolInfoQuery,
  EmbeddedPutOptionReports,
  EmbeddedPutOptionRequestBody,
  CreateVirtualPortfolioItemRequest,
  UpdateVirtualPortfolioItemRequest,
} from '@libs/api-reference';

import { TSE_API } from './endpoints';

type UpdateNetAverageData = {
  averagePrice: number;
  isin: string;
  bourseCodeId: number;
};

export function getPortfolio() {
  return http.get<PortfolioQuery>(`${TSE_API}/portfolio`, {
    schema: PortfolioQuery,
  });
}

export function getVirtualPortfolio() {
  return http.get<VirtualPortfolioQuery>(`${TSE_API}/virtualassets`, {
    schema: VirtualPortfolioQuery,
  });
}

export function createVirtualPortfolio(
  data: CreateVirtualPortfolioItemRequest
) {
  return http.post(`${TSE_API}/virtualassets`, data);
}

export function updateVirtualPortfolio(
  data: UpdateVirtualPortfolioItemRequest
) {
  return http.put(`${TSE_API}/virtualassets`, data);
}

export function deleteVirtualPortfolio(virtualPortfolioId: number) {
  return http.delete(`${TSE_API}/virtualassets/{virtualPortfolioId}`, {
    urlParams: { virtualPortfolioId },
  });
}

export function getEmbeddedPutOptionSymbols() {
  return http.get<EmbeddedPutOptionSymbolsQuery>(`${TSE_API}/tabaei/info`, {
    schema: EmbeddedPutOptionSymbolsQuery,
  });
}

export function getEmbeddedPutOptionSymbolInfo(isin: string) {
  return http.get<EmbeddedPutOptionSymbolInfoQuery>(
    `${TSE_API}/tabaei/{isin}`,
    {
      urlParams: { isin },
      schema: EmbeddedPutOptionSymbolInfoQuery,
    }
  );
}

export function createEmbeddedPutOptionRequest(
  data: EmbeddedPutOptionRequestBody
) {
  return http.post<object>(`${TSE_API}/tabaei`, data);
}

export function deleteEmbeddedPutOptionRequest(isin: string) {
  return http.delete<object>(`${TSE_API}/tabaei/{isin}`, {
    urlParams: { isin },
  });
}

export function updateEmbeddedPutOptionRequest(
  isin: string,
  data: EmbeddedPutOptionRequestBody
) {
  return http.put<object>(`${TSE_API}/tabaei/{isin}`, data, {
    urlParams: { isin },
  });
}

export function getEmbeddedPutOptionReportsRequest() {
  return http.get<EmbeddedPutOptionReports>(`${TSE_API}/tabaei/report`, {
    schema: EmbeddedPutOptionReports,
  });
}

export function updateNetAveragePrice(data: UpdateNetAverageData) {
  // eslint-disable-next-line @typescript-eslint/ban-types
  return http.put<{}>(`${TSE_API}/portfolio/averageprice`, data);
}
